// extracted by mini-css-extract-plugin
module.exports = {"container":"_3IW2tk","rating":"_5fBV8W","text":"Uz5ZK-","image":"_2lRWKR","shine-lines":"_3-_rjd"};